import Reveal from "@/components/Reveal";
import { STEPS } from "@/config/site";

export default function StepsSection({ title = "From interest to introduction" }) {
  return (
    <section className="bg-platinum py-16 sm:py-24 lg:py-28" data-testid="steps-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <h2 className="max-w-2xl font-display text-3xl font-bold tracking-tight text-ink sm:text-4xl">
            {title}
          </h2>
          <p className="mt-4 max-w-2xl text-lg leading-relaxed text-ink/75">
            A clear sequence, so you always know what happens next — and who decides what.
          </p>
        </Reveal>
        <ol className="mt-12 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((step, i) => (
            <Reveal key={step.num} delay={i * 0.08}>
              <li className="flex h-full flex-col border-t-2 border-cobalt/80 pt-5" data-testid={`step-item-${i}`}>
                <span className="font-display text-4xl font-extrabold text-silver">{step.num}</span>
                <h3 className="mt-4 font-display text-lg font-semibold leading-snug text-ink">
                  {step.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-ink/70">{step.desc}</p>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
}
